import { Helmet } from 'react-helmet';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import Navbar from '../../components/light/creative-agency/Navbar';
import Footer from '../../components/light/creative-agency/Footer';
import BlogTopAgencySEO from '../../components/light/blog/BlogTopAgencySEO';

export default function BlogWebsiteDevelopmentJawaharNagarTelangana() {
  return (
    <>
      <Helmet>
        <title>Best Website Development Company in Jawahar Nagar | Top Website Development Services Jawahar Nagar</title>
        <meta name="description" content="Looking for the best website development company in Jawahar Nagar? Aashway offers professional website development services in Jawahar Nagar, Telangana." />
        <link rel="canonical" href="https://aashway.com/blog/website-development-company-jawahar-nagar" />
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/light/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/light/assets/css/style.css" />
        <link rel="stylesheet" type="text/css" href="/light/assets/css/satoshi.css" />
        <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap" />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <BlogTopAgencySEO category="Website Development" city="Jawahar Nagar" state="Telangana" blogImage="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1400&q=80" aashwayImage="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1400&q=80" />
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
